/** Русское склонение: 1 день, 2 дня, 5 дней. */
function plural(n: number, one: string, few: string, many: string): string {
  const m10 = n % 10
  const m100 = n % 100
  if (m10 === 1 && m100 !== 11) return one
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few
  return many
}

/** Все тексты приложения. Язык один — переключатель убран. */
export const T = {
  // навигация
  navGame: 'Игра',
  navFriends: 'Друзья',
  navAwards: 'Достижения',
  navProfile: 'Профиль',

  // игра
  learned: 'выучено',
  level: 'Уровень',
  streakDays: (n: number) => `${n} ${plural(n, 'день', 'дня', 'дней')} подряд`,
  play: 'Играть',
  // выбор зоны таблицы перед игрой
  scopeTitle: 'Что тренируем',
  scopeSingle: 'Одну цифру',
  scopeUpto: 'До цифры',
  scopeAll: 'Всю таблицу',
  zoneSingle: (n: number) => `таблица на ${n}`,
  zoneUpto: (n: number) => `таблица до ${n}`,
  zoneAll: 'вся таблица',
  wholeTable: (pct: number) => `вся таблица · ${pct}%`,
  pickNumber: 'Выбери цифру',
  stickers: (got: number, total: number) => `${got} из ${total} наклеек`,

  // раунды
  choose: 'Выбери ответ',
  type: 'Набери ответ',
  match: 'Соедини пары',
  matchHint: 'Сначала пример, потом ответ',
  race: 'Гонка — 20 секунд',
  boss: 'Босс',
  solved: 'Решено:',
  correct: 'Верно!',
  oops: 'Смотри:',
  back: 'Назад',

  // итоги
  done: 'Готово!',
  accuracy: 'точность',
  repeat: 'Повтори:',
  again: 'Ещё раз',
  toHome: 'Домой',

  // друзья
  friendsTitle: 'Друзья',
  friendsSub: 'Кто дальше всех в таблице умножения',
  you: 'Ты',
  feed: 'Что нового',
  addFriend: 'Добавить',
  inviteTitle: 'Позвать друга',
  inviteWays: 'Есть два способа — выбери любой.',
  inviteWayCode: '1. Скажи другу свой код',
  inviteWayLink: '2. Или отправь ссылку',
  inviteCode: 'Твой код',
  inviteHint: 'Друг введёт его у себя внизу — и вы увидите успехи друг друга.',
  inviteLinkHint: 'Друг нажмёт на ссылку — и вы сразу станете друзьями.',
  copyCode: 'Скопировать код',
  copyLink: 'Скопировать ссылку',
  shareLink: 'Отправить ссылку',
  copied: 'Скопировано! Теперь отправь другу.',
  copyFailed: 'Не вышло скопировать — перепиши код вручную.',
  namePrompt: 'Напиши своё имя в профиле — иначе друзья увидят просто «Игрок» →',
  haveCode: 'А если код дали тебе',
  haveCodeHint: 'Набери код друга и нажми «Добавить».',
  friendPlaceholder: 'БЕЛКА-482',
  friendAdded: (name: string) => `Ура! ${name} теперь в твоём списке друзей 🎉`,
  friendsEmpty: 'Пока ты играешь один. Позови друга — будет веселее!',
  feedEmpty: 'Как только друзья начнут играть, здесь появятся их успехи.',
  remove: 'Убрать',
  removeConfirm: 'Убрать из друзей?',
  loading: 'Загружаем…',

  // достижения
  awardsTitle: 'Достижения',
  tabMe: 'Для меня',
  tabParent: 'Для родителя',
  toNextLevel: (n: number) => `до ${n} уровня`,
  thisWeek: 'На этой неделе',
  solvedTotal: 'Решено примеров',
  myStickers: 'Наклейки',
  medalsTitle: 'Медали таблиц',
  medalsCount: (got: number, total: number) => `${got} из ${total}`,
  weekDays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],

  // для родителя
  parentSub: 'Что ребёнок знает и над чем стоит поработать',
  timeToday: 'сегодня',
  streakWord: (n: number) => plural(n, 'день', 'дня', 'дней'),
  week: 'Неделя',
  byTable: 'По таблицам',
  weak: 'Слабые места',
  nothingYet: 'Пока пусто — сыграй первую игру.',

  // профиль
  profileTitle: 'Профиль',
  changePhoto: 'Изменить фото',
  firstName: 'Имя',
  lastName: 'Фамилия',
  age: 'Возраст',
  years: (n: number) => `${n} ${plural(n, 'год', 'года', 'лет')}`,
  loggedInMax: 'Вход через MAX выполнен',
  loggedInPhone: 'Вход выполнен — успехи сохраняются',

  // ключ восстановления
  keyTitle: 'Твой ключ',
  keyWhy: 'По нему все наклейки, уровни и дни подряд вернутся на новом телефоне.',
  keySend: 'Отправить родителям',
  keyCopy: 'Скопировать ключ',
  keyCopied: 'Скопировано! Отправь родителям, чтобы не потерялось.',
  keySecret: 'Ключ — только для родителей. Друзьям показывают другой код, он на вкладке «Друзья».',
  keyShare: (code: string) =>
    `Сохраните это сообщение. Ключ от «Умножайки»: ${code}. Если на новом телефоне игра начнётся с нуля — откройте ссылку, и все успехи вернутся.`,
  keyHave: 'Играл на другом телефоне? Введи ключ →',
  keyHaveStep: 'Ключ с прошлого телефона',
  keyEnter: 'Вернуть прогресс',
  keyPlaceholder: 'БЕЛКА-ЛУНА-4827',
  keyAskTitle: 'Вернуть прогресс?',
  keyLater: 'Не сейчас',
  keyWelcome: (name: string) => `С возвращением, ${name}! 🎉`,

  // вход через мессенджер
  loginMax: 'Войти через MAX',
  chooseLearned: (pct: number) => `${pct}% выучено`,
  sharePhone: 'Поделиться номером',
  phoneLinked: 'Номер сохранён — друзья найдут тебя по нему',
  removePhoto: 'Убрать фото',
  syncSaving: 'Сохраняем…',
  syncOffline: 'Нет связи — сохраним позже',
  syncIdle: 'Всё сохранено',
} as const

export type Strings = typeof T
